import api from "../../APIIntercepter";

async function getMyInfoAPI() {
  const url = `/user/data`;
  const res = await api.get(url);
  return res.data;
}

async function getPayedInformationAPI(classId) {
  const res = await api.get(
    "/classSchedule/getPayedInformation/" + classId,
  );
  return res.data;
}

async function getByClassIdAndStudentIdAndMonthAPI(classId, date) {
  const res = await api.get(
    `/classSchedule/getByClassIdAndStudentIdAndMonth/${classId}?date=${date}`,
  );
  return res.data;
}

async function getMyPaidClassesAPI() {
  const res = await api.get(`/bankslip/getMyPaidClasses`);
  return res.data;
}

async function getMyPaidTodayClassesAPI(date) {
  const res = await api.get(`/bankslip/getMyPaidTodayClasses?date=${date}`);
  return res.data;
}

async function changeMyPasswordAPI(params) {
  const res = await api.put("/user/student/changePassword", params);
  return res.data;
}

async function getPayedClassScheduleByIdAPI(id) {
  const res = await api.get(`/classschedule/gePayedClassScheduleById/${id}`);
  return res.data;
}

async function updateMyDetailsAPI(params) {
  const res = await api.put("/user/student/update", params);
  return res.data;
}

async function getScheduleFilesByClassIdAndDateAPI(classId, data) {
  const res = await api.get(`/schedulefile/getScheduleFilesByClassIdAndDate/${classId}/${data}`);
  return res.data;
}

async function getFreeClassSchedulesAPI() {
  const res = await api.get(`/classschedule/getFreeClassSchedules`);
  return res.data;
}

async function getStudentClassScheduleAssignsAPI() {
  const res = await api.get(`/classscheduleAssign/getStudentClassScheduleAssigns`);
  return res.data;
}

export {
  getMyInfoAPI,
  getPayedInformationAPI,
  getByClassIdAndStudentIdAndMonthAPI,
  getMyPaidClassesAPI,
  getMyPaidTodayClassesAPI,
  changeMyPasswordAPI,
  getPayedClassScheduleByIdAPI,
  updateMyDetailsAPI,
  getScheduleFilesByClassIdAndDateAPI,
  getFreeClassSchedulesAPI,
  getStudentClassScheduleAssignsAPI
};
